import React from "react";
import "./SectionAlert.css"

const SectionAlert = () => {
    return(
        <section className="section-alert">
            <div className="alert-content wrapper">
                <p className="alert-text">DZIĘKUJEMY ZA SEZON 2021, ZAPRASZAMY PONOWNIE W LATO 2022. <br/> <br/>
                *W PRZYPADKU CHĘCI SKORZYSTANIA PRZEZ GRUPY ZORGANIZOWANE PROSIMY O KONTAKT Z RECEPCJĄ.</p>
                <div className="alert-status">
                    <p>AKTUALNY STAN:</p>
                </div>
                <div className="alert-triangle"></div>
            </div>
        </section>
    )
}

export default SectionAlert;